import { Reveal } from "./Reveal";
import { useLang } from "@/lib/i18n";

export const Founder = () => {
  const { copy } = useLang();
  const f = copy.founder;

  return (
    <section id="founder" data-testid="founder-section" className="border-t hairline py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <Reveal className="lg:col-span-4">
          <div className="overflow-hidden">
            <img
              data-testid="founder-photo"
              src="/founder.jpg"
              alt={f.photoAlt}
              loading="lazy"
              className="w-full h-[420px] md:h-[560px] object-cover object-[50%_15%] scale-100 hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
          </div>
          <p className="mt-3 text-[10px] uppercase tracking-[0.35em] text-plum/50">{f.photoCap}</p>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-8">
          <p className="overline-label mb-6">{f.overline}</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08]">
            {f.title}
          </h2>
          <div className="mt-8 flex flex-col gap-5 max-w-2xl">
            {f.paragraphs.map((p, i) => (
              <p
                key={i}
                className={
                  i === 0
                    ? "font-serif italic text-xl md:text-2xl leading-relaxed text-plum"
                    : "text-sm md:text-base font-light leading-relaxed text-plum/70"
                }
              >
                {p}
              </p>
            ))}
          </div>
          <div className="mt-10 border-t hairline pt-6">
            <p className="text-sm font-light text-plum/60">{f.signoff}</p>
            <p data-testid="founder-name" className="font-serif italic text-3xl md:text-4xl mt-2 text-gold-dark">
              {f.name}
            </p>
            <p className="text-[10px] uppercase tracking-[0.3em] text-plum/50 mt-2">
              {f.role} — House of Alvirah
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
